import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import PropTypes from 'prop-types';
import arrowLeft from "./assets/arrowLeft.svg";
import checked from "./assets/checked.svg";
import cross from "./assets/cross.svg";
import documents from "./assets/documents.svg";
import dropdownArrow from "./assets/dropdownArrow.svg";
import externalLink from "./assets/externalLink.svg";
import closeDesktop from "./assets/closeDesktop.svg";
import closeMobile from "./assets/closeMobile.svg";
var icons = {
  arrowLeft: arrowLeft,
  checked: checked,
  cross: cross,
  documents: documents,
  dropdownArrow: dropdownArrow,
  externalLink: externalLink,
  closeDesktop: closeDesktop,
  closeMobile: closeMobile
};
var sizes = {
  arrowLeft: {
    width: 30,
    height: 12
  },
  checked: {
    width: 11,
    height: 9
  },
  cross: {
    width: 12,
    height: 12
  },
  documents: {
    width: 28,
    height: 37
  },
  dropdownArrow: {
    width: 14,
    height: 8
  },
  externalLink: {
    width: 13,
    height: 13
  },
  present: {
    width: 25,
    height: 30
  },
  // loads over network
  closeDesktop: {
    width: 24,
    height: 24
  },
  closeMobile: {
    width: 24,
    height: 24
  }
};
export default function Icon(props) {
  var name = props.name,
    className = props.className,
    scale = props.scale,
    src = props.src,
    lazy = props.lazy;
  var Svg = icons[name];
  var style = {
    width: sizes[name] ? sizes[name].width * scale : null,
    height: sizes[name] ? sizes[name].height * scale : null
  };
  return Svg ? /*#__PURE__*/React.createElement(Svg, _extends({
    className: className
  }, style)) : /*#__PURE__*/React.createElement("img", {
    className: className,
    loading: lazy ? 'lazy' : undefined,
    role: "presentation",
    src: src.replace('{{name}}', name),
    style: style
  });
}
Icon.defaultProps = {
  scale: 1,
  src: '//static.beeline.ru/upload/images/emoji/{{name}}.svg'
};
Icon.propTypes = process.env.NODE_ENV !== "production" ? {
  name: PropTypes.string,
  className: PropTypes.any,
  scale: PropTypes.number,
  src: PropTypes.string
} : {};